import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
var REQUEST_KEY = "disableRejectionCodeSet";
export var useDisableRejectionCodeSet = function () {
    var dispatch = useDispatch();
    var disabledRejectionCodeSet = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var disablingRejectionCodeSet = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : false; });
    var errorDisableRejectionCodeSet = useSelector(function (state) { var _a, _b, _c; return (_c = (_b = (_a = state.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var disableRejectionCodeSet = function (id, version) {
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "PATCH",
            path: "/billing/Api/V1/RejectionCodes/".concat(id, "/disable"),
            body: { version: version },
            // extraHeaders: getRejectionCodesUserIdHeader(),
        }));
    };
    var clearDisableRejectionCodeSet = function () {
        dispatch(clearCustomRequest(REQUEST_KEY));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        disableRejectionCodeSet: disableRejectionCodeSet,
        clearDisableRejectionCodeSet: clearDisableRejectionCodeSet,
        disabledRejectionCodeSet: disabledRejectionCodeSet,
        disablingRejectionCodeSet: disablingRejectionCodeSet,
        errorDisableRejectionCodeSet: errorDisableRejectionCodeSet,
    };
};
